import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/services_/tech-support-for-seniors_/montclair")({
  beforeLoad: () => {
    throw redirect({ href: "/services/tech-support-for-seniors", statusCode: 301 });
  },
});
